<div class="container status pago-error">
  <div class="row justify-content-center">
    <div class="col-12 col-lg-6 text-center">
      <i class="fal fa-exclamation-circle status__icon"></i>
      <div
        *ngIf="contenido && contenido.titulo"
        [innerHTML]="contenidoTitulo"
      ></div>
      <div
        *ngIf="contenido && contenido.descripcion"
        class="contenedor-info-estado-pago"
      >
        <i class="fal fa-times-circle contenedor-info-estado-pago__icono"></i>
        <div [innerHTML]="contenidoDescripcion"></div>
      </div>
      <app-resumen-pago
        [referencia]="pago.referencia"
        [resumenesDePago]="resumenesDePago"
      ></app-resumen-pago>
    </div>
    <div
      class="col-12 d-flex justify-content-center my-4 flex-column flex-md-row"
    >
      <button
        type="button"
        class="reintentar-pago mx-1 mb-3 mb-md-0"
        (click)="redirectToPago()"
      >
        Reintentar Pago
      </button>
      <a (click)="regresarAlComercio(pago.urlRetorno)" class="go-back mb-0 mx-1"
        >Regresar al comercio</a
      >
    </div>
    <div class="col-12 text-center my-3">
      <a href="https://www.placetopay.com/web/" target="_blank">
        <img
          src="https://static.placetopay.com/placetopay-logo.svg"
          class="attachment-0x0 size-0x0 logo-placetopay"
          alt="placetopay"
          loading="lazy"
        />
      </a>
    </div>
  </div>
</div>
